import React, { useEffect, useRef, useState } from 'react'
import { Avatar, Form, Input } from 'antd'
import usePostApi from '../../../../../../config/hooks/api/post/usePostApi';
import { getInitials } from '../../../../../../config/utils';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../../../../components/Modal';
import ReportComment from './ReportComment';
import Prompt from '../../../../../../components/Prompt';
import { GoAlertFill } from 'react-icons/go';
import { TbTrashXFilled } from "react-icons/tb";
import Button from '../../../../../../components/FormElements/Button';
import { setAppLoading } from '../../../../../../store/common/generalSlice';

const PostComments = ({ data, refreshFeed }) => {
    const { addPollComment, addPostComment, deleteComment } = usePostApi()
    const dispatch = useDispatch()

    const [inputValue, setInputValue] = useState('')
    const [allComments, setAllComments] = useState(data?.comments ? data?.comments.sort((a, b) => a.id - b.id).reverse() : [])
    const [comments, setComments] = useState(
        allComments.length && allComments.length > 2 ? allComments.slice(0, 3) :
            allComments.length && allComments.length < 2 ? allComments : []
    )
    const [limit, setLimit] = useState(3)
    const [offset, setOffset] = useState(0)
    const [openReportModal, setOpenReportModal] = useState(false)
    const [reportedComment, setReportedComment] = useState(null)
    const [openDeleteCommentPrompt, setOpenDeleteCommentPrompt] = useState(false)
    const [deletePromptMessage, setDeletePromptMessage] = useState('')
    const [commentToDeleteId, setCommentToDeleteId] = useState(-1)

    const formRef = useRef(null);
    const [form] = Form.useForm();

    const user = useSelector(state => state?.auth?.loggedInUser)

    const handleCommentInput = (e) => {
        setInputValue(e.target.value)
    }

    const showNextComments = () => {
        const newOffset = offset + limit;
        setOffset(newOffset);
    }

    const showPreviousComments = () => {
        const newOffset = offset - limit;
        setOffset(Math.max(newOffset, 0)); // Ensure offset doesn't go below 0
    }


    const onFinish = async (values) => {
        try {
            if (inputValue) {
                dispatch(setAppLoading(true))
                const comment = inputValue

                let response;
                if (data && data?.type && data?.type.toLowerCase() == 'post') {
                    response = await addPostComment({ comment }, data?.id)
                }
                else {
                    response = await addPollComment({ comment }, data?.id)
                }
                if (response) {
                    const data = response?.data?.post ? response?.data?.post : response?.data?.poll
                    setInputValue('')
                    form.resetFields();
                    refreshFeed({
                        type: 'updateComment',
                        data
                    })
                    dispatch(setAppLoading(false))
                }
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    };

    const handleClick = () => {
        formRef.current.submit();
    };

    const handleDeleteCommentPrompt = (commentId) => {
        if(commentId){
            setOpenDeleteCommentPrompt(true)
            setDeletePromptMessage('Are you sure you want to delete this message?')
            setCommentToDeleteId(commentId)
        }
    }

    const handleDeletePromptResponse = (res) => {
        if(res === true) handleDeleteComment()
        setCommentToDeleteId(-1)
        closeModal()
    }

    const handleDeleteComment = async () => {
        try {
            if(commentToDeleteId <= -1) return

            const response = await deleteComment(commentToDeleteId)
            if(response) {
                refreshFeed()
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleReportComment = async (comment) => {
        if(!comment) return
            
        setReportedComment(comment)
        setOpenReportModal(true)
    }

    const closeModal = () => {
        setOpenReportModal(false)
        setOpenDeleteCommentPrompt(false)
    }


    useEffect(() => {
        setComments(
            allComments.length && allComments.length > 2 ? allComments.slice(0, 3) :
                allComments.length && allComments.length < 2 ? allComments : []
        )
        setInputValue('')
    }, [allComments])


    return (
        <React.Fragment>
            {data && (
                <div className='flex flex-col justify-center'>
                    <div className='flex items-center'>
                        <Avatar 
                            size={40}
                            className='h-[40px]' 
                            src={
                            <img 
                                src={data?.user?.imageThumbUrl} 
                                alt="avatar" 
                                className='img-fluid object-fit' 
                            />
                            } 
                        />
                        <div className='flex flex-col pl-4 w-full justify-center'>
                            <Form
                                form={form}
                                ref={formRef}
                                name="myForm"
                                onFinish={onFinish}
                                layout="vertical"
                            >
                                <Form.Item
                                    label=""
                                    name="comments"
                                    className='mb-0'
                                >
                                    <Input
                                        className='h-10 comment-box'
                                        placeholder="What's on your mind?"
                                        value={inputValue}
                                        onChange={handleCommentInput}
                                        type='text'
                                        maxLength={500}
                                        style={{ borderRadius: '25px !important' }}
                                        suffix={
                                            <div className='flex justify-end'>
                                                <div className='lg:w-full md:w-full sm:w-full w-1/2 mr-2'> 
                                                    {/* <FaCamera className='text-slate-400' /> */}
                                                    {/* <IoSend
                                                        className='text-slate-400 text-2xl cursor-pointer'
                                                        onClick={handleClick}
                                                    /> */}
                                                    <Button.Basic
                                                        onClick={handleClick}
                                                        disabled={!inputValue}
                                                        icon={null}
                                                        loading={false}
                                                        type="primary"
                                                        size='small'
                                                        text='Send'
                                                        className='btn-primary md:w-fit sm:w-fit w-full'
                                                    />
                                                </div>
                                                {/* <span onClick={() => toggleEmoji(data?.id)}>
                                                    {(openEmojis && selectedPost == data?.id) && <EmojiPicker onEmojiClick={onEmojiClick} />}
                                                    <FaRegSmile className='text-slate-400' />
                                                </span> */}
                                            </div>
                                        }
                                    />
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                    <div className='flex justify-start pt-6 flex-col'>
                        {data?.comments && data?.comments.length ? <h6 className='heading-6 font-semibold mb-4'>Comments</h6> : ''}
                        <div className='flex flex-col'>
                            {data?.comments?.length ? data?.comments.slice(0, offset + limit).map((item, index) => (
                                <React.Fragment key={item.id}>
                                    <div className='flex items-start pb-1'>
                                        <Avatar size={40} className='h-[40px]' src={item?.user?.imageThumbUrl} alt="avatar">
                                            {/* eslint-disable-next-line no-undef */}
                                            {getInitials(item?.user?.fullName)}
                                        </Avatar>
                                        <div className='w-full ml-2 p-3 pt-0 flex justify-between items-start'>
                                            <div>
                                                <h6 className='heading-6 text-sm font-bold mb-1'>{item?.user?.fullName}</h6>
                                                <p className='font-medium text-xs text-slate-500'>{item?.comment}</p>
                                            </div>
                                            <div>
                                                {
                                                    //if post belongs to user
                                                    ((data?.user?.id && user?.id) && data?.user?.id == user?.id) ||
                                                        //if post does not belong to user but comment belong to user
                                                        ((data?.user?.id && user?.id) && data?.user?.id != user?.id &&
                                                            item?.user?.id == user?.id) ?
                                                        (
                                                            <small 
                                                                className='text-xs font-semibold cursor-pointer mr-2' 
                                                                onClick={()=>handleDeleteCommentPrompt(item?.id)}
                                                            >
                                                                <TbTrashXFilled className='icon-alert' />
                                                            </small>
                                                        ) : (
                                                            <small 
                                                                className='text-xs font-semibold cursor-pointer' 
                                                                onClick={()=>handleReportComment(item)}
                                                            >
                                                                <GoAlertFill className='icon-alert' />
                                                            </small>
                                                        )}
                                            </div>
                                        </div>
                                    </div>
                                    {index != comments.length - 1 ? (
                                        <hr className='border-dashed border-1 border-gray-200 mb-3' />
                                    ) : null}
                                </React.Fragment>
                            )) : null}
                        </div>
                        <div className='mt-2'>
                            {offset + limit < allComments.length && (
                                <small className='cursor-pointer font-medium' onClick={showNextComments}>See More</small>
                            )}
                            {offset > 0 && (
                                <small className={`${offset + limit < allComments.length && 'ml-3'} cursor-pointer font-medium`} onClick={showPreviousComments}>Previous</small>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <Modal.Basic open={openReportModal} onCancel={closeModal} width={300}>
                <div className='p-4'>
                    <ReportComment refreshFeed={refreshFeed} comment={reportedComment} closeModal={closeModal} />
                </div>
            </Modal.Basic>

            <Modal.Basic open={openDeleteCommentPrompt} onCancel={closeModal} width={250}>
                <Prompt.Basic 
                    message={deletePromptMessage} 
                    onChange={handleDeletePromptResponse} 
                    closeModal={closeModal} 
                />
            </Modal.Basic>
        </React.Fragment>
    )
}

export default PostComments
